// L'espace de modération est passé à React (js/react/ecrans/Moderation.jsx).
//
// Les deux prédicats et la fenêtre de suspension ont été sortis dans
// `moderation-outils.js` : ils sont appelés d'un peu partout, et les laisser ici
// obligeait le composant à importer le fichier qui l'importe.
//
// On les réexporte pour ne rien casser chez ceux qui les importaient d'ici.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Moderation from "../react/ecrans/Moderation.jsx";

export { estModerateur, estSuspendu, suspendreMembre, supprimerCompteMembre } from "./moderation-outils.js";

export const rendre = vueReact(Moderation);
